<template>
  <div class="notifications">
    <div class="notifications__inner px-2">
      <span v-if="!notifications.length" class="text-caption">You don’t have any Notifications</span>
      <NotificationItem
        v-for="(notification) in notifications"
        :key="notification.Notification_ID"
        :notification="notification"
        @updated="getNotifications"
      />
    </div>
    <div class="d-flex justify-space-between mx-1 my-1">
      <v-btn
        v-if="notifications.length"
        small
        color="red"
        class="white--text"
        @click="deleteAllNotifications"
      >
        Delete All
      </v-btn>
      <v-btn
        small
        color="primary"
        @click="showAllNotifications = !showAllNotifications"
      >
        Show All
      </v-btn>
    </div>
    <AllNotifications
      v-if="showAllNotifications"
      v-model="showAllNotifications"
    />
  </div>
</template>
<script>
export default {
  components: {
    NotificationItem: () => import('@/components/notifications/NotificationItem.vue'),
    AllNotifications: () => import('@/components/notifications/AllNotifications.vue')
  },
  name: 'NotificationsList',
  data () {
    return {
      showAllNotifications: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    notifications () {
      return this.$store.getters.getNotifications
    }
  },
  methods: {
    getNotifications () {
      this.axios.get('/api/notifications', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.$store.dispatch('setNotifications', { notifications: result.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    deleteAllNotifications () {
      this.axios.delete('/api/notifications/all', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'All notifications cleared' })
        this.getNotifications()
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>
<style lang="scss">
  .notifications {
    min-width: 290px;
    width: auto;
    max-width: 400px;
    &__inner {
      max-height: 40vh;
      min-height: 50px;
      overflow: auto;
    }
  }
</style>
